import { useInsurancePolicy } from 'pages/InsurancePolicy/useInsurancePolicy';
import { useLatestLoan } from 'hooks/webapi';
import useBundle from 'hooks/useBundle';

export const useBusinessNoOverdue = () => {
  const { isBundleAccepted } = useBundle();
  const { latestLoan } = useLatestLoan();
  const { isInsurancePolicyEnabled } = useInsurancePolicy();

  const applyExtraFees = isInsurancePolicyEnabled || isBundleAccepted;

  const total =
    (latestLoan?.totalOutstandingAmount || 0) +
    (latestLoan?.penaltyAmount || 0) +
    (latestLoan?.commissionAmount || 0) +
    ((applyExtraFees && latestLoan?.openAgreementExtraFeesAmount) || 0);

  return { total };
};
